/* DocumentViewDrawer.tsx */
import React from 'react';
import { Modal, Button } from 'reactstrap';
import FilePreview from './FilePreview';

interface FileInfo {
  documentKey: string;
  documentExtension: string;
  documentName: string;
}

interface DocumentViewDrawerProps {
  fileInfo: FileInfo;
  show: boolean;
  model: string;
  onClose: () => void;
  onDownload: () => void;
}

const DocumentViewDrawer: React.FC<DocumentViewDrawerProps> = ({
  fileInfo,
  show,
  model,
  onClose,
  onDownload,
}) => (
  <Modal
    isOpen={show}
    toggle={onClose}
    className="modal-fullscreen"
  >
    <div className="modal-header d-flex justify-content-between align-items-center">
      <h5 className="modal-title mb-0">{fileInfo.documentName}</h5>
      <div>
        <Button color="link" onClick={onDownload}>
          <i className="ri-download-2-fill fs-4"></i>
        </Button>
        <Button color="link" onClick={onClose}>
          <i className="ri-close-fill fs-4"></i>
        </Button>
      </div>
    </div>

    <div className="modal-body p-0" style={{ height: 'calc(100vh - 56px)' }}>
      <FilePreview fileInfo={fileInfo} model={model} />
    </div>
  </Modal>
);

export default DocumentViewDrawer;